// FIT: runs after every redraw. When the title and description don't fit above the price area, the description is shortened
// first, then the title (keeping its " - Variant" ending), word by word with "…"; lines that still don't fit are hidden whole,
// so nothing is cut mid-line. Real text shortening (not CSS line-clamp), so PNG/PDF export and print match the preview.
// Ported unchanged from the original pages.

export function fitLabels(root: HTMLElement): void {
  root.querySelectorAll<HTMLElement>('[data-fit]').forEach(block => {
    // exact positions, not scrollHeight (which rounds to whole pixels)
    const edge = () => block.getBoundingClientRect().bottom + 0.01;
    const overflows = () => [...block.children].some(c => c.getBoundingClientRect().bottom > edge());
    if(!overflows()) return;
    // 1. Description: drop words from the end, then drop it entirely
    const desc = block.querySelector<HTMLElement>('[data-desc]');
    if(desc){
      shortenText(desc, overflows, 4, false);
      if(overflows()) desc.style.display = 'none';
    }
    // 2. Title: drop words, keeping a " - Variant" ending
    const title = block.querySelector<HTMLElement>('[data-title]');
    if(title && overflows()) shortenText(title, overflows, 1, true);
    // 3. Anything still crossing the edge (e.g. extra-info lines) is hidden whole, never half-cut
    if(overflows()){
      const limit = edge();
      block.querySelectorAll<HTMLElement>('*').forEach(el => {
        if(!el.children.length && el.getBoundingClientRect().bottom > limit) el.style.visibility = 'hidden';
      });
    }
  });
}

function shortenText(el: HTMLElement, overflows: () => boolean, minWords: number, keepSuffix: boolean): void {
  const full = el.textContent.trim();
  let head = full, tail = '';
  if(keepSuffix){
    const i = full.lastIndexOf(' - ');
    if(i > 0){ head = full.slice(0, i); tail = full.slice(i); }
  }
  const words = head.split(/\s+/);
  while(overflows() && words.length > minWords){
    words.pop();
    el.textContent = words.join(' ').replace(/[\s,;:.\-–—]+$/, '') + '…' + tail;
  }
}
